import { requests } from '../../../utils';
import { IOfferManagement } from './dto/IOfferManagement';
import {
    INFLUENCER_CONTRACT,
    INFLUENCER_INITIAL_OFFER,
    INFLUENCER_OFFER,
    INFLUENCER_OFFER_MANAGEMENT,
    INFLUENCER_OFFER_MODAL,
} from '../../../utils/endpoints';
import { IOfferManagementFilter } from './dto/IOfferManagementFilter';
import { ICampaignOverview } from '../../../model/briefing/overview/ICampaignOverview';
import { IInviteContractInfluencer, IInviteInfluencer } from '../../../model/book/Invites';
import { IOffer } from '../../../model/offer/IOffer';
import { IDeclineOffer } from './dto/IDeclineOffer';
import { IContract } from '../../../model/shared/IContract';

export const ManagementOfferService = {
    getOfferList: (params: IOfferManagementFilter): Promise<IOfferManagement> =>
        requests.get(INFLUENCER_OFFER_MANAGEMENT, params),
    getOfferModalDetail: (id: string, isLongTerm: boolean): Promise<ICampaignOverview> =>
        requests.get(`${INFLUENCER_OFFER_MODAL}/${id}`, { isLongTerm }),
    sendInitialOffer: (id: string, formData: FormData) =>
        requests.post(`${INFLUENCER_INITIAL_OFFER}/${id}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        }),
    sendCounterOffer: (id: string, formData: FormData) =>
        requests.put(`${INFLUENCER_OFFER}/${id}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        }),
    acceptOffer: (id: string) => requests.put(`${INFLUENCER_OFFER}/accept/${id}`, {}),
    withdrawOffer: (id: string) => requests.put(`${INFLUENCER_OFFER}/withdraw/${id}`, {}),
    declineOffer: (id: string, body: IDeclineOffer) => requests.put(`${INFLUENCER_OFFER}/decline/${id}`, body),
    getOfferHistory: (id?: string): Promise<IOffer[]> => requests.get(`${INFLUENCER_OFFER_MODAL}/history/${id}`),
};
export const InfluencerContractService = {
    getContractModalDetail: (id: string): Promise<ICampaignOverview> =>
        requests.get(`${INFLUENCER_CONTRACT}/modal/${id}`),
    // sendInitialContract: (id: string, formData: FormData) =>
    //     requests.post(`${INFLUENCER_CONTRACT}/initial/${id}`, formData, {
    //         headers: {
    //             'Content-Type': 'multipart/form-data',
    //         },
    //     }),
    sendCounterContract: (id: string, formData: FormData) =>
        requests.put(`${INFLUENCER_CONTRACT}/${id}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        }),
    acceptContract: (id: string) => requests.put(`${INFLUENCER_CONTRACT}/accept/${id}`, {}),
    acceptContractAnnex: (annexId: string) => requests.put(`${INFLUENCER_CONTRACT}/annex/accept/${annexId}`, {}),
    withdrawContract: (id: string) => requests.put(`${INFLUENCER_CONTRACT}/withdraw/${id}`, {}),
    declineContract: (id: string, body: IDeclineOffer) => requests.put(`${INFLUENCER_CONTRACT}/decline/${id}`, body),
    getContractHistory: (id?: string): Promise<IContract[]> =>
        requests.get(`${INFLUENCER_CONTRACT}/modal/history/${id}`),
};
